import React, { useState } from "react";
import styled from "styled-components";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import { useEditEventById } from "lib/hooks";
import { Input } from "antd";
import { Form, message } from "antd";
import SubmitButton from "../../profile/Button";

interface CollapsibleProps {
  isVisible: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  margin: 0;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const CollapseButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  width: 100%;
  border-radius: 4px;
  background-color: #f8f8f8;
  color: black;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CollapsibleContent = styled.div<CollapsibleProps>`
  max-height: ${props => (props.isVisible ? "800px" : "0")};
  overflow: hidden;
  margin-left: 1rem;
  transition: max-height 0.3s ease;
`;

const SmallText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

const FormBox = styled.div`
  margin-bottom: 10px;
  width: 100%;
`;

const SubmitContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 250px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

type SocialMediaProps = {
  event: any;
};

const SocialMedia: React.FC<SocialMediaProps> = ({ event }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [form] = Form.useForm();
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const { mutate: updateEvent } = useEditEventById();

  const handleSubmit = (values: any) => {
    const { id, ...restEvent } = event;
    const payload = {
      id: id,
      data: {
        ...restEvent,
        twitter: values.x,
        facebook: values.facebook,
        linkedin: values.linkedin,
        instagram: values.instagram,
      },
    };

    updateEvent(payload, {
      onSuccess: () => {
        message.success("Event Updated");
      },
      onError: error => {
        message.error("Update failed");
      },
    });
  };

  return (
    <Container>
      <CollapseButton onClick={toggleVisibility}>
        Social Media Links
        {isVisible ? <DownOutlined /> : <RightOutlined />}
      </CollapseButton>

      <CollapsibleContent isVisible={isVisible}>
        <Top>
          <Form
            layout="vertical"
            form={form}
            onFinish={handleSubmit}
            initialValues={{
              x: event?.twitter || "",
              facebook: event?.facebook || "",
              linkedin: event?.linkedin || "",
              instagram: event?.instagram || "",
            }}
            requiredMark={false}
          >
            <FormBox style={{ flex: 1 }}>
              <Form.Item label="x (formerly Twitter)" name="x">
                <Input style={{ width: "97%", fontSize: "0.8rem" }} />
              </Form.Item>
            </FormBox>

            <FormBox style={{ flex: 1 }}>
              <Form.Item label="Facebook" name="facebook">
                <Input style={{ width: "97%", fontSize: "0.8rem" }} />
              </Form.Item>
            </FormBox>

            <FormBox style={{ flex: 1 }}>
              <Form.Item label="Linkedin" name="linkedin">
                <Input style={{ width: "97%", fontSize: "0.8rem" }} />
              </Form.Item>
            </FormBox>

            <FormBox style={{ flex: 1 }}>
              <Form.Item label="Instagram" name="instagram">
                <Input style={{ width: "97%", fontSize: "0.8rem" }} />
              </Form.Item>
            </FormBox>

            <SubmitContainer>
              <SubmitButton form={form}>Save changes</SubmitButton>
            </SubmitContainer>
          </Form>
        </Top>
      </CollapsibleContent>
    </Container>
  );
};

export default SocialMedia;
